<div class="search-container">
  <div class="flex-1-1-full" [class.p-2]="!showCard">
    @if (showCard) {
      <div class="datatable-card">
        <ng-container *ngTemplateOutlet="layoutContent"></ng-container>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="layoutContent"></ng-container>
    }
  </div>
</div>

<ng-template #layoutContent>
  <div class="flex-column gap-1">
    <div class="flex-row space-between align-center gap-1">
      <div class="flex-column">
        <ng-content select="[layoutTitle]"></ng-content>
        <ng-content select="[layoutSubtitle]"></ng-content>
      </div>

      <div class="flex-row gap-1 align-center">
        <ng-content select="[layoutActions]"></ng-content>
      </div>
    </div>

    <ng-content select="[layoutContent]"></ng-content>

    @if (!hideTable) {
      <div class="table-wrapper">
        <ng-content select="[layoutTable]"></ng-content>
      </div>
    }
  </div>
</ng-template>
